import React, {useEffect, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {getCountries} from "../../../store/reducers/CountriesSlice";
import {apiClient} from "../../../utils/ApiClient";
import {useAppDispatch, useAppSelector} from "../../../utils/Hooks";
import {Option} from "../../common/form/ElogSelect";
import {getServices} from "../../../store/reducers/ServicesSlice";
import {getUsers} from "../../../store/reducers/UsersSlice";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import 'react-datepicker/dist/react-datepicker.css';
import Autosuggest, {SuggestionsFetchRequestedParams} from "react-autosuggest";

interface InquirySearchProps {
}

export const InquirySearch: React.FC<InquirySearchProps> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const {search} = useLocation();

    const usersState = useAppSelector((state) => state.users);
    const countriesState = useAppSelector(state => state.countries);
    const servicesState = useAppSelector((state) => state.services);
    const infoState = useAppSelector(state => state.info);

    const [startCountry, setStartCountry] = useState<string>("");
    const [fromDate, setFromDate] = useState<string>('');
    const [toDate, setToDate] = useState<string>('');
    const [user, setUser] = useState<string>("-1");
    const [destinationCountry, setDestinationCountry] = useState<string>("0");
    const [status, setStatus] = useState<string>("unarchived");
    const [perpage, setPerpage] = useState<number>(80);
    const [client, setClient] = useState<string>("");
    const [service, setService] = useState<string>("0");
    const [amountFrom, setAmountFrom] = useState<number | undefined>(undefined);
    const [amountTo, setAmountTo] = useState<number | undefined>(undefined);
    const [minus, setMinus] = useState<boolean>(false);
    const [noOffer, setNoOffer] = useState<boolean>(true);

    const [clientSuggestions, setClientSuggestions] = useState<Option[]>([]);

    const fetchClients = async (inputValue: string) => {
        try {
            const apiResponse = await apiClient.get(`suggest/client?search=${encodeURIComponent(inputValue)}`);
            const clients: Option[] = apiResponse.data.map((client: { id: number; name: string }) => ({
                label: client.name,
                value: client.id.toString(),
            }));
            setClientSuggestions(clients);
        } catch (error) {
            console.error('Fetch clients error:', error);
        }
    };

    const onClientSuggestionsFetchRequested = ({value}: SuggestionsFetchRequestedParams) => {
        if (value.length > 1) {
            fetchClients(value);
        } else {
            setClientSuggestions([]);
        }
    };

    const onClientSuggestionsClearRequested = () => {
        setClientSuggestions([]);
    };

    const onVendorSuggestionsClearRequested = () => {
        // setVendorSuggestions([]);
    };

    const onClientSuggestionSelected = (event: React.FormEvent<any>, {suggestion}: { suggestion: Option }) => {
        setClient(suggestion.label);
    };

    const onVendorSuggestionSelected = (event: React.FormEvent<any>, {suggestion}: { suggestion: Option }) => {
        //setVendor(suggestion.label);
    };

    const renderSuggestion = (suggestion: Option) => (
        <div>
            {suggestion.label}
        </div>
    );

    const handleSearch = () => {

        const searchParams = new URLSearchParams();
        searchParams.set("startCountry", startCountry);
        searchParams.set("fromDate", fromDate);
        searchParams.set("toDate", toDate);
        searchParams.set("user", user);
        searchParams.set("destinationCountry", destinationCountry);
        searchParams.set("status", status);
        searchParams.set("perpage", perpage.toString());
        searchParams.set("client", client);
        searchParams.set("service", service);
        searchParams.set("amountFrom", amountFrom?.toString() || "");
        searchParams.set("amountTo", amountTo?.toString() || "");
        searchParams.set("minus", minus ? "1" : "0");
        searchParams.set("nooffer", noOffer ? "1" : "0");
        searchParams.set("tab", new URLSearchParams(search).get("tab") || '');

        const newUrl = `/inquiries?${searchParams.toString()}`;

        navigate(newUrl);

    };

    useEffect(() => {

        dispatch(getCountries());
        dispatch(getServices(false));
        dispatch(getUsers());

        const urlParams = new URLSearchParams(window.location.search);

        setStartCountry(urlParams.get("startCountry") || "0");
        setFromDate(urlParams.get("fromDate") || '');
        setToDate(urlParams.get("toDate") || '');
        setUser(urlParams.get("user") || usersState.users.some((u) => u.id === infoState?.me?.id && u.logistician === 1)
            ? String(infoState?.me?.id)
            : "-1");
        setDestinationCountry(urlParams.get("destinationCountry") || "0");
        setStatus(urlParams.get("status") || "unarchived");
        setPerpage(Number(urlParams.get("perpage")) || 80);
        setClient(urlParams.get("client") || "");
        setService(urlParams.get("service") || "0");
        setAmountFrom(Number(urlParams.get("amountFrom")) || undefined);
        setAmountTo(Number(urlParams.get("amountTo")) || undefined);
        setMinus(urlParams.get("minus") === "1");
        setNoOffer(urlParams.get("nooffer") === "1");

    }, []);

    const userOptions: Option[] = [
        { value: "-1", label: "Kõik" },
        ...usersState.users
            .filter((user) => user.logistician === 1)
            .map((user) => ({
                value: user.id.toString(),
                label: `${user.firstname} ${user.lastname}`,
            })),
    ];

    const countryOptions: Option[] = [
        {value: '0', label: 'Kõik'},
        ...countriesState.countries.map((country) => ({
            value: country.id.toString(),
            label: country.name,
        })),
    ];

    const serviceOptions: Option[] = [
        {value: '0', label: 'Kõik'},
        ...servicesState.services.map((service) => ({
            value: service.id.toString(),
            label: service.name,
        })),
    ];

    return (
        <div className="filter clear">
            <div className="content">
                <p>
                    <label>
                        <strong>Alguskoht:</strong>
                    </label>
                    <select
                        name="startCountry"
                        className="w150"
                        value={startCountry}
                        onChange={(e) => setStartCountry(e.target.value)}
                    >
                        {countryOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    &nbsp;&nbsp;&nbsp;
                    <label>
                        <strong>Logistik:</strong>
                    </label>
                    <select
                        name="user"
                        className="w150"
                        value={user ?? '-1'}
                        onChange={(e) => setUser(e.target.value)}
                    >
                        {userOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    &nbsp;&nbsp;&nbsp;
                    <span style={{display: 'inline-flex'}}>
                        <label><strong>Periood:</strong></label>
                        <DatePicker
                            key={'from'}
                            value={fromDate}
                            onChange={(date) => setFromDate(date ? dayjs(date).format('DD.MM.YYYY') : '')}
                            dateFormat={'dd.MM.yyyy'}
                            className={'date'}
                            locale="et"
                            showYearDropdown={true}
                            showMonthDropdown={true}
                        />
                        –
                        <DatePicker
                            key={'to'}
                            value={toDate}
                            onChange={(date) => setToDate(date ? dayjs(date).format('DD.MM.YYYY') : '')}
                            dateFormat={'dd.MM.yyyy'}
                            className={'date'}
                            locale="et"
                            showYearDropdown={true}
                            showMonthDropdown={true}
                        />
                        </span>
                </p>
                <p>
                    <label>
                        <strong>Sihtkoht:&nbsp;&nbsp;&nbsp;&nbsp;</strong>
                    </label>
                    <select
                        name="destinationCountry"
                        className="w150"
                        value={destinationCountry}
                        onChange={(e) => setDestinationCountry(e.target.value)}
                    >
                        {countryOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    &nbsp;&nbsp;&nbsp;
                    <label>
                        <strong>Staatus:</strong>
                    </label>
                    <input
                        type="radio"
                        id="status1"
                        name="status"
                        value="all"
                        checked={status === "all"}
                        onChange={() => setStatus("all")}
                    />
                    <label htmlFor="status1">Kõik</label>
                    <input
                        type="radio"
                        id="status2"
                        name="status"
                        value="archived"
                        checked={status === "archived"}
                        onChange={() => setStatus("archived")}
                    />
                    <label htmlFor="status2">Arhiveeritud</label>
                    <input
                        type="radio"
                        id="status3"
                        name="status"
                        value="unarchived"
                        checked={status === "unarchived"}
                        onChange={() => setStatus("unarchived")}
                    />
                    <label htmlFor="status3">Arhiveerimata</label>
                    &nbsp;&nbsp;&nbsp;
                    <label>
                        <strong>Kirjeid lehel:</strong>
                    </label>
                    <input
                        style={{width: "50px"}}
                        type="text"
                        name="perpage"
                        value={perpage}
                        onChange={(e) => setPerpage(Number(e.target.value))}
                    />
                </p>
                <p>
                        <span style={{display: 'inline-flex'}}>
                        <label>
                            <strong>Klient:&nbsp;&nbsp;&nbsp;&nbsp;</strong>
                        </label>
                        <Autosuggest
                            suggestions={clientSuggestions}
                            onSuggestionsFetchRequested={onClientSuggestionsFetchRequested}
                            onSuggestionsClearRequested={onClientSuggestionsClearRequested}
                            onSuggestionSelected={onClientSuggestionSelected}
                            getSuggestionValue={(suggestion: Option) => suggestion.label}
                            renderSuggestion={renderSuggestion}
                            inputProps={{
                                value: client,
                                onChange: (_, {newValue}) => {
                                    setClient(newValue);
                                },
                            }}
                            theme={{
                                container: 'react-autosuggest__container',
                                suggestionsContainer: (clientSuggestions.length > 0)
                                    ? 'react-autosuggest__suggestions-container visible'
                                    : 'react-autosuggest__suggestions-container',
                                suggestionsList: 'react-autosuggest__suggestions-list',
                                suggestion: 'react-autosuggest__suggestion',
                                suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
                            }}
                        />
                        </span>
                    &nbsp;&nbsp;&nbsp;
                    <label>
                        <strong>Teenuse liik:</strong>
                    </label>
                    <select
                        name="service"
                        className="w150"
                        value={service}
                        onChange={(e) => setService(e.target.value)}
                    >
                        {serviceOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    &nbsp;&nbsp;&nbsp;
                    <label>
                        <strong>Kogus:</strong>
                    </label>
                    <input
                        type="number"
                        style={{width: "40px"}}
                        step={0.1}
                        name="amountFrom"
                        value={amountFrom || ""}
                        onChange={(e) => setAmountFrom(Number(e.target.value))}
                    />
                    ldm –
                    <input
                        type="number"
                        style={{width: "40px"}}
                        step={0.1}
                        name="amountTo"
                        value={amountTo || ""}
                        onChange={(e) => setAmountTo(Number(e.target.value))}
                    />{" "}
                    ldm
                    &nbsp;&nbsp;&nbsp;
                </p>
            </div>
            <p className="action">
                <button type="button" onClick={handleSearch}>
            <span>
              <strong>Otsi</strong>
            </span>
                </button>
                <a
                    target="_blank"
                    className="filter-secondary"
                    href={`https://elog.etslogistika.ee/excel_queries.php?export=1&startCountry=${encodeURIComponent(startCountry)}&user=${encodeURIComponent(user)}&destination_country=${encodeURIComponent(destinationCountry)}&status=${encodeURIComponent(status)}&perpage=${encodeURIComponent(perpage.toString())}&client=${encodeURIComponent(client)}&service=${encodeURIComponent(service)}&amountFrom=${encodeURIComponent((amountFrom ?? '').toString())}&amountTo=${encodeURIComponent((amountTo ?? '').toString())}&minus=${encodeURIComponent((minus ? 1 : 0).toString())}&nooffer=${encodeURIComponent((noOffer ? 1 : 0).toString())}&sent=&type=&tab=unanswered`}
                >
                    Excel download
                </a>{" "}
            </p>
        </div>
    );
};